/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener('DOMContentLoaded', function() {
    const popups = document.querySelectorAll('.booom-popup');
    
    popups.forEach(popup => {
        const parentWrapper = popup.closest('.booom-popup--wrapper');
        const triggerType = popup.dataset.triggerType || 'timer';
        const cookieDays = parseInt(popup.dataset.cookieDays);
        const enableCookie = popup.dataset.enableCookie !== 'false';
        const popupId = popup.id;

        console.log(enableCookie);

        // Skip if cookie exists (except for click trigger)
        if (enableCookie && triggerType !== 'click' && getCookie(`popup_shown_${popupId}`)) {
            return;
        }


        // Setup trigger based on type
        console.log(triggerType);
        switch (triggerType) {
            case 'timer':
                const showAfter = parseInt(popup.dataset.showAfter) * 1000;
                setTimeout(() => {
                    parentWrapper.classList.add('is-active');
                    if (enableCookie) {
                        setCookie(`popup_shown_${popupId}`, 'true', cookieDays);
                    }
                }, showAfter);
                break;

            case 'click':
                const anchor = popup.dataset.clickAnchor;
                if (anchor) {
                    document.querySelectorAll(anchor).forEach(trigger => {
                        trigger.addEventListener('click', (e) => {
                            console.log('clicked');
                            e.preventDefault();
                            parentWrapper.classList.add('is-active');
                        });
                    });
                }
                break;

            case 'scroll':
                const scrollTarget = popup.dataset.scrollDistance;
                let targetPixels;

                if (scrollTarget.endsWith('%')) {
                    const percentage = parseInt(scrollTarget);
                    targetPixels = (document.documentElement.scrollHeight - window.innerHeight) * (percentage / 100);
                } else if (scrollTarget.endsWith('vh')) {
                    const vh = parseInt(scrollTarget);
                    targetPixels = (window.innerHeight * vh) / 100;
                } else {
                    targetPixels = parseInt(scrollTarget);
                }

                window.addEventListener('scroll', () => {
                    if (window.scrollY >= targetPixels) {
                        parentWrapper.classList.add('is-active');
                        if (enableCookie) {
                            setCookie(`popup_shown_${popupId}`, 'true', cookieDays);
                        }
                    }
                });
                break;

            case 'exit':
                document.addEventListener('mouseleave', (e) => {
                    if (e.clientY <= 0) {
                        parentWrapper.classList.add('is-active');
                        if (enableCookie) {
                            setCookie(`popup_shown_${popupId}`, 'true', cookieDays);
                        }
                    }
                });
                break;
        }

        // Close popup when clicking overlay
        parentWrapper.addEventListener('click', (e) => {
            if (e.target === parentWrapper) {
                parentWrapper.classList.remove('is-active');
                if (enableCookie && triggerType !== 'click') {
                    setCookie(`popup_shown_${popupId}`, 'true', cookieDays);
                }
            }
        });

        if (popup.dataset.showExitIcon === 'true') {
            const closeButton = parentWrapper.querySelector('.popup-close-button');
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    parentWrapper.classList.remove('is-active');
                    if (enableCookie && triggerType !== 'click') {
                        setCookie(`popup_shown_${popupId}`, 'true', cookieDays);
                    }
                });
            }
        }
    });
});

function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
